import React from 'react';
import InteractiveButton from '../../InteractiveButton/InteractiveButton';
import { ElementSize } from '../../../types/element-size';
import { IDbCycleSettings } from '../../../store/models/cycles';
import CycleSettings from '../../../enums/cycle-setting.enum';

type PendingSettingsBannerProps = {
  pendingSettings: IDbCycleSettings;
  onApplyAll: () => void;
  isLoading?: boolean;
};

const PendingSettingsBanner: React.FC<PendingSettingsBannerProps> = ({
  pendingSettings,
  onApplyAll,
  isLoading = false,
}) => {
  const getModeLabel = (mode: CycleSettings) => {
    switch (mode) {
    case CycleSettings.PostWeld:
      return 'Post Weld Heat Treatment';
    case CycleSettings.PreHeat:
      return 'Pre-Heat';
    case CycleSettings.PercentageTimer:
      return 'Percentage Timer';
    case CycleSettings.Recorder:
      return 'Recorder';
    default:
      return mode;
    }
  };

  return (
    <div className="mb-6 rounded-lg border border-warning bg-warning/10 p-6 dark:border-warning dark:bg-warning/5">
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1">
          <div className="mb-2 flex items-center gap-2">
            <svg className="h-6 w-6 text-warning" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <h3 className="text-lg font-semibold text-black dark:text-white">Pending Cycle Settings</h3>
          </div>
          <p className="text-gray-600 dark:text-gray-400 text-sm">
            You have settings that were created during cycle generation and haven&apos;t been applied to the device yet.
          </p>
          <div className="mt-3 text-sm">
            <p className="text-black dark:text-white">
              <span className="font-medium">Mode:</span> {getModeLabel(pendingSettings.mode)}
            </p>
            {pendingSettings.name && (
              <p className="text-black dark:text-white">
                <span className="font-medium">Recipe Name:</span> {pendingSettings.name}
              </p>
            )}
            {pendingSettings.steps && pendingSettings.steps.length > 0 && (
              <p className="text-black dark:text-white">
                <span className="font-medium">Steps:</span> {pendingSettings.steps.length} configured
              </p>
            )}
          </div>
        </div>
        <div className="flex flex-col gap-2 sm:flex-row">
          <InteractiveButton size={ElementSize.MD} onClick={onApplyAll} isLoading={isLoading}>
            Apply to All
          </InteractiveButton>
        </div>
      </div>
    </div>
  );
};

export default PendingSettingsBanner;
